import { Grid, Stack } from '@mui/material'
import { Field } from 'pages/TeenagersRecord/components/Field'
import React from 'react'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { booleanSimNao, formatChoiceText } from 'utils/text.util'
import {
  formatWelcomedOtherReasons,
  validateChoiceField,
  validateStringNumber,
} from 'components/HearingSummary/utils/validate-field.util'

type TabContentProps = {
  data: HearingIdentificationType
}

export const TabWelcomeContent: React.FC<TabContentProps> = ({ data }) => {
  const hasWecomedInRJ =
    data &&
    data.identificacaoAdolescente &&
    booleanSimNao(data.identificacaoAdolescente.acolhidoInsticionalmenteEstadoRJ)

  return (
    <Grid item xs={12}>
      <Stack direction='column' spacing={2}>
        <Field
          label='Está ou já esteve em situação de rua?'
          value={[formatChoiceText(data.identificacaoAdolescente.situacaoRua)]}
          direction='row'
        />
        <Field
          label='Já foi acolhido institucionalmente?'
          value={[formatChoiceText(data.identificacaoAdolescente.acolhidoInsticionalmente)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.acolhidoInsticionalmente) && (
          <>
            <Field
              label='Rio de Janeiro?'
              value={[
                validateChoiceField(data.identificacaoAdolescente.acolhidoInsticionalmenteEstadoRJ),
              ]}
              direction='row'
            />
            {!hasWecomedInRJ && (
              <Field
                label='Estado:'
                value={[
                  validateStringNumber(
                    data.identificacaoAdolescente.descricaoIdAcolhidoInsticionalmenteOutroEstado,
                  ),
                ]}
                direction='row'
              />
            )}
            {hasWecomedInRJ && (
              <>
                <Field
                  label='Município:'
                  value={[
                    validateStringNumber(
                      data.identificacaoAdolescente
                        .descricaoIdAcolhidoInsticionalmenteMunicipioEstadoRJ,
                    ),
                  ]}
                  direction='row'
                />
                <Field
                  label='Instituição:'
                  value={[
                    validateStringNumber(
                      data.identificacaoAdolescente
                        .descricaoIdAcolhidoInsticionalmenteServicoAcolhimento,
                    ),
                  ]}
                  direction='row'
                />
              </>
            )}

            <Field
              label='Qual o motivo:'
              value={[formatWelcomedOtherReasons(data.identificacaoAdolescente)]}
              direction='row'
            />
          </>
        )}
      </Stack>
    </Grid>
  )
}
